export const setPlan = {
  exploringNeeds: [
    { required: true, message: '请输入探寻需求', trigger: 'blur' }
  ],
  matchingScheme: [
    { required: true, message: '请输入匹配方案', trigger: 'blur' }
  ]
}
